<template>
  <div class="tabs">
    <div
      v-for="option in tabOptions"
      :key="option.title"
      :aria-pressed="option.active"
      class="tabs__item"
      :class="{ tabs__item__active: option.active, tabs__item__disabled: option.disabled }"
      role="button"
      :tabindex="option.disabled ? -1 : 0"
      @click="selectTab(option)"
      @keydown.enter="selectTab(option)"
      @keydown.space="(event: Event) => selectTab(option, event, true)"
    >
      {{ option.title }}
    </div>
  </div>
</template>

<script setup lang="ts">
type Props = {
  tabOptions: any[]
}
defineProps<Props>()
type Emits = {
  (e: 'changeTab', value): void
}
const emits = defineEmits<Emits>()
function selectTab(option, event?: Event, preventDefault?: boolean) {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  if (option.active || option.disabled) return
  emits('changeTab', option.value)
}
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';
.tabs {
  align-items: flex-start;
  background-color: variables.$color-pure-white;
  cursor: pointer;
  display: flex;
  &__item {
    @include font-mixins.desktop-bold-label;
    box-shadow: 0px 0px 0px 1px variables.$color-greyscale-secondary inset;
    color: variables.$color-greyscale-content;
    padding: 8px 12px;
    text-align: center;
    &:first-child {
      border-radius: 8px 0px 0px 8px;
    }
    &:last-child {
      border-radius: 0px 8px 8px 0px;
    }
    &__active {
      background-color: variables.$color-primary;
      box-shadow: 0px 0px 0px 1px variables.$color-primary inset;
      color: variables.$color-pure-white;
    }
    &__disabled {
      cursor: not-allowed;
    }
  }
}
</style>
